import { Images } from "../Images";
import tw from "tailwind-styled-components";
import { useSelector } from "react-redux";

const Topbar = () => {    
    const userDetails = useSelector(state => state.UserReducer.userDetails);
    return (
        <Header>
            <HeaderContainer>
                {/* Left - Logo */}
                <div className="flex items-center gap-3">
                    <Logo src={userDetails?.logo || Images.Logo} alt="Kipinn Logo" />
                    <div>
                        <h1 className="text-lg font-semibold text-gray-900">
                           {userDetails?.clientName || 'Kipinn'}
                        </h1>

                        <p className="text-xs text-gray-500">
                            Complete Your Booking
                        </p>
                    </div>
                </div>
                {/* Right - Actions */}
                {/* <HeaderActions>

                    <WhatsAppHeaderBtn
                    // onClick={() => {
                    //     const phone = apiData?.property?.ownerMobile;
                    //     if (!phone) return;

                    //     window.open(`https://wa.me/${phone}`, "_blank");
                    // }}
                    >
                        <FaWhatsapp className="w-4 h-4" />
                        <span className="hidden sm:inline">WhatsApp</span>
                    </WhatsAppHeaderBtn>

                    <CallHeaderBtn
                    // onClick={() => {
                    //     const phone = apiData?.property?.ownerMobile;
                    //     if (!phone) return;

                    //     window.location.href = `tel:${phone}`;
                    // }}
                    >
                        <FaPhoneAlt className="w-4 h-4" />
                        <span className="hidden sm:inline">Call</span>
                    </CallHeaderBtn>

                </HeaderActions> */}

            </HeaderContainer>
        </Header>
    )
}
export default Topbar

const Header = tw.header`border-b sticky top-0 bg-white z-40 shadow-sm`;
const HeaderContainer = tw.div`max-w-5xl mx-auto px-4 lg:px-0 py-4 flex items-center justify-between`;
const Logo = tw.img`w-12 sm:w-14`;
const HeaderActions = tw.div`
  flex items-center gap-2 sm:gap-3
`;
const WhatsAppHeaderBtn = tw.button`
  flex items-center gap-1 sm:gap-2
  bg-green-500 hover:bg-green-400
  text-white px-3 sm:px-4 py-2
  rounded-lg font-medium text-xs sm:text-sm
  transition-all duration-300 shadow-sm
`;

const CallHeaderBtn = tw.button`
  flex items-center gap-1 sm:gap-2
  bg-blue-500 hover:bg-blue-600
  text-white px-3 sm:px-4 py-2
  rounded-lg font-medium text-xs sm:text-sm
  transition-all duration-300 shadow-sm
`;